<div *ngIf="(notifications$ | async)" class="container-message">
    <ng-container *ngFor="let item of notifications$ | async; index as i " >
        <div *ngIf="isIncluded(item.type)" class="message" [ngClass]="item.type == 'error' ?'is-danger' : ''">
            <a *ngIf="item.type == 'error'" class="delete-message" (click)="deleteNotification(item.id)">Meldung löschen</a>
            <span [innerHTML]="item.notification"></span>
            <button
                    *ngIf="item.type !== 'error'"
                    tabindex="0"
                    style="position:absolute; left:-9999px; width:1px; height:1px; opacity:0;"
                    aria-hidden="true">
                Focus
            </button>

        </div>
    </ng-container>

</div>
